export type PixKeyType = "CPF" | "CNPJ" | "EMAIL" | "PHONE" | "RANDOM";

export type GowdPixOutBody = {
  amount: {
    currency: "BRL" | string;
    value: string;
  };
  paymentMethod: "PIX";
  customer: {
    fullName: string;
    email?: string;
    phone?: string;
    birth?: string;
    document?: {
      type?: "CPF" | "CNPJ";
      number?: string;
    };
  };
  bank: {
    pix: {
      type: PixKeyType;
      key: string;
    };
  };
  description?: string;
  webhookUrl: string;
  code: string;
};

export type GowdPixOutResponse = {
  id?: string;
  amount?: string;
  status?: string;
  fee?: {
    fixed?: string;
    variable?: string;
    additional?: string;
  };
  errorMessage?: string;
  createdAt?: string;
  [key: string]: any;
};

export const querystringPixOut = (params?: Record<string, any>) => {
  if (!params) return "";
  const q = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && `${v}`.trim() !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join("&");
  return q ? `?${q}` : "";
};

export const parseBRL = (v: string) => {
  // aceita "500", "500.50", "R$ 500,00"
  const cleaned = (v || "")
    .replace(/[^\d,.-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : NaN;
};

export interface PixRefundBody {
  accountId: string;
  originalEndToEnd: string;
  amount: number;
  currency: "BRL";
  reason?: string;
}

export interface UpdatePixLimitsBody {
  dailyLimitBrl: number;
  nightlyLimitBrl: number;
  instantLimitBrl: number;
}

// util p/ querystring simples
export const querystring = (obj: Record<string, any>) => {
  const sp = new URLSearchParams();
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    sp.set(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : "";
};

export const normalizeDate = (dateStr?: string, endOfDay?: boolean) => {
  if (!dateStr) return "";
  if (dateStr.includes("T")) return dateStr; // já é datetime/rfc3339
  return endOfDay ? `${dateStr}T23:59:59.999Z` : `${dateStr}T00:00:00.000Z`;
};

// response
export type StatementDirection = "IN" | "OUT" | string;

export interface CorpxStatementItem {
  timestamp: string;
  amount: number;
  currency: string;
  operation?: string;
  description?: string;
  balance?: number;
  transactionType?: string; // PIX_IN, PIX_OUT...
  method?: string; // DYNAMIC_QR_CODE...
  status?: string; // SUCCESS...
  direction?: StatementDirection;
  identifier?: string;

  payer?: {
    name?: string;
    document?: string;
    bankCode?: string;
    bankName?: string;
    branch?: string;
    account?: string;
    pixKey?: string;
  };

  payee?: {
    name?: string;
    document?: string;
    bankCode?: string;
    bankName?: string;
    branch?: string;
    account?: string;
    pixKey?: string;
  };

  // Campos úteis p/ refund/conciliacao
  endToEndId?: string; // pode existir em alguns retornos
  originalEndToEnd?: string; // seu exemplo traz esse
  refundEndToEndIds?: string[];
  qrcodeId?: string;
  qrcodeIdentifier?: string;
  reconciliationId?: string;
  feeServiceType?: string;
}

export interface CorpxStatementResponse {
  accountId: string;
  items: CorpxStatementItem[];
  // se o backend retornar paginação, adicione:
  // page?: number; size?: number; total?: number;
}
